import { NAV_LINKS, SERVICES } from "../../data/constants";
import styles from "./Footer.module.css";

export default function Footer() {
  const handle = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div>
          <p className={styles.brand}>
            Royal <span className={styles.gold}>Horizon</span>{" "}
            <span className={styles.sub}>Mobility Ltd</span>
          </p>
          <p className={styles.tagline}>
            Your trusted partner in global travel, tourism, and international
            mobility. Based in Nairobi, serving the world.
          </p>
          <p className={styles.motto}>"Your Partner in Global Mobility"</p>
        </div>

        <div>
          <h5 className={styles.colHead}>Quick Links</h5>
          <ul className={styles.list}>
            {NAV_LINKS.map(({ label, id }) => (
              <li key={id}>
                <a href={`#${id}`} onClick={(e) => handle(e, id)}>{label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h5 className={styles.colHead}>Services</h5>
          <ul className={styles.list}>
            {SERVICES.slice(0, 5).map((s) => (
              <li key={s.title}>
                <a href="#services" onClick={(e) => handle(e, "services")}>{s.title}</a>
              </li>
            ))}
            <li>
              <a href="#careers-abroad" onClick={(e) => handle(e, "careers-abroad")}>
                Job Opportunities
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        © {new Date().getFullYear()} Royal Horizon Mobility Ltd. All rights reserved.
        &nbsp;·&nbsp; Nanak House, Kimathi Street, 4th Floor, Room 407, Nairobi
      </div>
    </footer>
  );
}
